import { createFileRoute } from '@tanstack/react-router';
import { TransfersListPage } from '@/features/transfers-list/transfers-list-page.js';

export const Route = createFileRoute('/_app/transfers/')({
  component: TransfersListPage,
});
